import './Forms.css'

function Forms() {

  return (
    <div className='forms-container'>
      {/* <h1>School Forms</h1> */}
      <p>
        <h1 className='tele-form-header'>School Forms</h1>

        School, daycare, and camp forms require medical staff and the provider to review the patient’s chart to ensure that accurate information is communicated.
        <br />
        <br />
        To submit a form for completion:
        <ol>
          <li>Fill out the <strong><a href="/FormRequestCoverSheet.pdf" target="_blank" rel="noopener noreferrer">
            Form Request Cover Sheet</a></strong> in its entirety.</li>
          <li>Include the Cover Sheet with the forms to be completed.</li>
          <li>Complete as much demographic information as possible (such as name, date of birth, and contact details) on the requested forms.</li>
          <li>For patients with food allergies, clearly list all food allergens that should be avoided directly on the form.</li>
        </ol>
        The completed Cover Sheet and requested forms may be sent electronically via the <strong><a href='https://10561.portal.athenahealth.com/' target="_blank" rel="noreferrer">Patient Portal</a></strong>, dropped off, or mailed to the office.
        <br />
        <br />
        Standard turn-around time is <strong>2 weeks</strong> for <strong>$30</strong>.
        <br />
        Expedited turn-around time is <strong>2 business days</strong> for <strong>$40</strong>.
        <br />
        <br />
        Payment is required prior to completion of forms.
        <br />
        <br />
        <strong>Mailing address:</strong>
        <br />
        Allergy & Asthma of Central Maryland
        <br />
        9891 Broken Land Pkwy, Suite 100
        <br />
        Columbia, MD 21046
      </p>

    </div>
  )
}
export default Forms